export default __webpack_public_path__ + "static/media/hubspot-icon.0520e38d.svg";